import { useRef } from 'react';
import { uniqueId } from '../utilities/uniqueId.js';

function useUniqueId(slug) {
  const id = useRef(uniqueId(slug));
  return id.current;
}

export { useUniqueId };
